module.exports = __webpack_public_path__ + "img/ayuda-amebas-rurales.02a98a8c.png";